import { types } from '../actions/types';
import uniq from 'lodash/uniq';
const CryptoJS = require("crypto-js");
const initialState = {
    messages: [],
    linkMessages: [],
    logMessages: [],
    listCount: 0,
    loadEarlier: false,
    loadMore: false,
    channelKey: null,
    messageKeys: null,
    userMessageKeys: null
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case types.SET_IMAGE_LIKED_STATUS:
        return { 
          ...state, 
          imageLikedStatus: action.payload 
        };
  
      case types.GET_IMAGE_LIKED_STATUS:
        return { 
          ...state, 
          imageLikedStatus: action.payload 
        };
  
      case types.COMMENT_CHANGED:
        return { 
          ...state, 
          commentContent: action.payload 
        };
  
      case types.GET_COMMENT_STATUS:
        return { 
          ...state, 
          commentStatus: action.payload 
        };

      case types.GET_MESSAGE_THREAD:
        const { thread, msgKey } = action.payload;
        // console.log('GET_MESSAGE_THREAD',thread, msgKey);
        return {
          ...state,
          messageThread: thread,
          msgKey: msgKey
        };

      // CHAT TYPE MESSAGES =================================================
      case types.GET_MESSAGES_SUCCESS:
          return {
              ...state,
              messages: action.payload
          };
      case types.GET_MORE_MESSAGES_SUCCESS:
          let uniqMsg = uniq([...action.payload, ...state.messages]);
          return {
              ...state,
              messages: (state.messages && state.messages.length > 0) ? uniqMsg : [action.payload]
            };

      case types.GET_MESSAGES_FAIL:
        return {
          ...state,
          messages: action.payload 
        };

      // LINK TYPE MESSAGES =================================================
      case types.GET_LINK_MESSAGES_SUCCESS:
        return {
          ...state,
          linkMessages: action.payload
        };
      case types.GET_MORE_LINK_MESSAGES_SUCCESS:
      console.log('GOT MORE MESSAGES @ REDUCER', action.payload);
      return {
          ...state,
          linkMessages: (state.linkMessages && state.linkMessages.length > 0) ? uniq([...action.payload, ...state.linkMessages]) : [action.payload]
        };

      case types.GET_LINK_MESSAGES_FAIL:
        return {
          ...state,
          linkMessages: action.payload
        };

      // LOG TYPE MESSAGES =================================================

      case types.GET_LOG_MESSAGES_SUCCESS:
        return {
          ...state,
          logMessages: action.payload
        };
      case types.GET_MORE_LOG_MESSAGES_SUCCESS:
        return {
            ...state,
            logMessages: (state.logMessages && state.logMessages.length > 0) ? uniq([...action.payload, ...state.logMessages]) : [action.payload]
          };

      case types.GET_LOG_MESSAGES_FAIL:
        return {
          ...state,
          logMessages: action.payload
        };
      case types.UPLOADING_PHOTO_MESSAGE_STARTED:
        console.log(`%cStart Photo Upload Spinner Reducer Triggered`,'color: greenyellow');
        return {...state, isPhotoUploading: true };
      case types.UPLOADING_PHOTO_MESSAGE_COMPLETED:
        console.log(`%cStop Photo Upload Spinner Reducer Triggered`,'color: greenyellow');
        return {...state, isPhotoUploading: false };
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/js/reducers/chat-reducer.js